// extracted by mini-css-extract-plugin
export default {"helper-text":"HelperText_helper-text__9PHzv","helper-text_icon":"HelperText_helper-text_icon__+QCw0","asterix":"HelperText_asterix__118fR","visible":"HelperText_visible__dFapE"};